/**
 * @class
 * @constructor
 * @param {String} translationKey
 * @param {String} isoCode
 * @param {String} iconSrc
 */
class Locale {
    constructor (translationKey, isoCode, iconSrc) {
        Object.assign(this, {
            translationKey,
            isoCode,
            iconSrc
        });
    }

    get lang() {
        return this.isoCode.substring(0, 2);
    }
}


export default {
    german: new Locale('locale.de', 'de-DE', require('@/assets/de_32.png')),
    english: new Locale('locale.en', 'en-US', require('@/assets/gb_32.png')),
    dutch: new Locale('locale.nl', 'nl-NL', require('@/assets/nl_32.png')),
    czech: new Locale('locale.cs', 'cs-CZ', require('@/assets/cz_32.png'))
};
